<mat-card appearance="outlined" class="card">
  <mat-card-actions>
    <div class="flex-row start-center gap-20">
      <button matButton="elevated" color="primary" (click)="onAddType()">
        <mat-icon>add</mat-icon>
        <span i18n>Type</span>
      </button>
      <button matButton="elevated" (click)="onBack()">
        <mat-icon>arrow_back</mat-icon>
        <span i18n>Back</span>
      </button>
    </div>
  </mat-card-actions>
  <br />
  <mat-card-content>
    <mat-form-field>
      <mat-label i18n="@filter">Filter</mat-label>
      <input matInput (keyup)="applyFilter($event)" #input />
    </mat-form-field>
    <table
      mat-table
      [dataSource]="dataSource"
      matSort
      matSortActive="name"
      matSortDirection="asc"
    >
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header i18n>
          Type Name
        </th>
        <td mat-cell *matCellDef="let element">{{ element.name }}</td>
      </ng-container>
      <ng-container matColumnDef="externalId">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          i18n="@@externalId"
        >
          External Id
        </th>
        <td mat-cell *matCellDef="let element">{{ element.externalId }}</td>
      </ng-container>
      <ng-container matColumnDef="edit">
        <th mat-header-cell *matHeaderCellDef i18n="@@edit">Edit</th>
        <td mat-cell *matCellDef="let element">
          <mat-icon style="flex: 1 1 10%" (click)="updateType(element)"
            >edit</mat-icon
          >
        </td>
      </ng-container>
      <ng-container matColumnDef="delete">
        <th mat-header-cell *matHeaderCellDef i18n="@@delete">Delete</th>
        <td mat-cell *matCellDef="let element">
          <mat-icon
            (click)="deleteType(element)"
            style="color: gray; flex: 1 0 10%"
            >delete</mat-icon
          >
        </td>
      </ng-container>
      <ng-container matColumnDef="translations">
        <th mat-header-cell *matHeaderCellDef i18n="@@translations">Translations</th>
        <td mat-cell *matCellDef="let element">
          @let translationStatus = translationDialogService.getStatusIcon(element.translations);
          <button
            mat-icon-button
            type="button"
            (click)="openTranslationsDialog(element)"
            [attr.aria-label]="translationStatus.label"
            [matTooltip]="translationStatus.label"
          >
            <mat-icon [color]="translationStatus.color">
              {{ translationStatus.icon }}
            </mat-icon>
          </button>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="4" i18n="@@NotMatchingFilter">
          No data matching the filter "{{ input.value }}"
        </td>
      </tr>
    </table>
  </mat-card-content>
</mat-card>
